import React, { createContext, useCallback, useContext, useState } from "react";

interface TalkToUsContextType {
  isOpen: boolean;
  open: () => void;
  close: () => void;
}

const TalkToUsContext = createContext<TalkToUsContextType | undefined>(
  undefined
);

export const TalkToUsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const open = useCallback(() => setIsOpen(true), []);
  const close = useCallback(() => setIsOpen(false), []);

  return (
    <TalkToUsContext.Provider value={{ isOpen, open, close }}>
      {children}
    </TalkToUsContext.Provider>
  );
};

export function useTalkToUsState() {
  const context = useContext(TalkToUsContext);
  if (!context) {
    throw new Error("useTalkToUs must be used within a TalkToUsProvider");
  }
  return context;
}
